import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-microsoft',
  templateUrl: './microsoft.component.html',
  styleUrls: ['./microsoft.component.scss']
})
export class MicrosoftComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
